import {
  getMaterialsWithPublishStatus,
  unPublishMaterial,
  saveMaterialAccess
} from './api'
import { materialSlice } from './reducer'

const { selectedMaterial, resetMaterial } = materialSlice.actions

export {
  getMaterialsWithPublishStatus,
  unPublishMaterial,
  selectedMaterial,
  saveMaterialAccess,
  resetMaterial
}
